'use strict';

angular.module('webAgro1App').controller('UsuarioAlertasCtrl',

  // eslint-disable-next-line max-lines-per-function, max-params
  function($uibModalInstance, usuario, Flash, UsuariosService) {
    this.usuario = usuario;
    this.alertas = {
      boletim: false,
      aplicacoes_que_divergem: false,
      tarefas_atrasadas: false,
      glebas_sem_visita: false
    };
    this.configuracoes = {
      glebas_sem_visita: {
        dias_sem_visita: 0
      }
    };

    this.init = function() {
      const _this = this;
      _this.saving = false;
      if (this.usuario.usuario_alertas.length) {
        this.usuario.usuario_alertas.forEach(function(alerta) {
          _this.alertas[alerta.tipo] = true;
          _this.configuracoes[alerta.tipo] = alerta.configuracoes;
        });
      }
    };

    this.init();

    this.close = function() {
      $uibModalInstance.dismiss('cancel');
    };

    this.save = function() {
      const _this = this;
      _this.saving = true;
      UsuariosService.saveNotifications(this.usuario, this.alertas, this.configuracoes).then(function(result) {
        _this.usuario.usuario_alertas = result.data.usuario_alertas;
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      }, function(error) {
        console.error('Erro ao registrar alertas do usuário', error);
        Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
      })
        .finally(function() {
          _this.saving = false;
          $uibModalInstance.dismiss('save');
        });
    };
  });
